import { reactive } from "vue";
import { ExpenseResource } from "../../js/classes/Api/Expense";
export default function useExpenseStore() {
    const state = reactive({
        expenses: [],
        loadPercentage: 0,
    });
    async function loadExpenses(filters = null, page = 0) {
        return await ExpenseResource.all({ offset: page > 0 ? page * 25 : 0, filters: JSON.stringify(filters), sort_order: 'tax_at DESC' }).then(async (response) => {
            state.loadPercentage = Math.min(response.data.to, response.data.total) / (response.data.total / 100);
            state.expenses = state.expenses.concat(response.data.results.map((expense) => {
                return {
                    id: expense.id,
                    tax_at: expense.tax_at,
                    reference: expense.reference,
                    supplier: {
                        id: expense.contact.id,
                        primary_display_as: expense.contact.primary_display_as,
                        secondary_display_as: expense.contact.secondary_display_as,
                        primary_telephone: expense.contact.primary_telephone,
                        email: expense.contact.email,
                        post_code: expense.contact.post_code,
                    },
                    description: expense.description,
                    amount_outstanding: expense.amount_outstanding,
                    credit: undefined,
                    payment: undefined,
                    gross: expense.gross,
                };
            }));
            if ((response.data.total / response.data.limit) > (response.data.to / response.data.limit)) {
                return await loadExpenses(filters, response.data.to / response.data.limit);
            }
            else {
                return state.expenses;
            }
        });
    }
    return {
        state,
        loadExpenses,
    };
}
